import { defineComponent as r, computed as i } from "vue";
import l from "./td-longtail-vue-components257.js";
const d = /* @__PURE__ */ r({
  __name: "color-selector",
  props: {
    variants: { default: void 0 },
    value: { default: void 0 },
    noLink: { type: Boolean },
    isAccessible: { type: Boolean, default: !0 },
    large: { type: Boolean },
    medium: { type: Boolean }
  },
  emits: ["select-variant", "input"],
  setup(s) {
    const t = s, a = (e) => {
      const n = {};
      return e?.code && (n.background = e.code), n;
    }, o = i(() => (t.variants?.length || 0) > 1);
    return { __sfc: !0, props: t, style: a, hasSelection: o, isChecked: (e) => {
      if (o.value)
        return e === t.value ? "true" : "false";
    }, Tooltip: l };
  }
});
export {
  d as default
};
